import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const FivePaisa: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { reDirectPage, updatePartialConfigs, changeApiKey, validateClientId, isMobile } =
    brokerSpecificHandles;
  const {
    clientId,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    apiKey,
    secretKey,
    pin,
    selectedBrokerConfig,
    brokerExtras,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;
  const apiClientId = pin || brokerExtras?.api_user_id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage({ pin: apiClientId }, false) : validateClientId();
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Code"
        id={`${broker}-client-Code`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Code"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="Encryption Key"
          id={`${broker}-encryption-key`}
          value={secretKey}
          placeholder="Enter Encryption Key"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="User ID"
          id={`${broker}-user-id`}
          value={apiClientId}
          placeholder="Enter User ID"
          onHandleChange={(value) => updatePartialConfigs({ pin: value })}
        />
      )}

      {shouldShowApiKey && (
        <button type="button" onClick={() => switchPage()}>
          <i className="fa-regular fa-gear fa-spin" />
          Steps to Create New App details?
        </button>
      )}

      {isClientValidated && !shouldShowApiKey && (
        <button type="button" onClick={changeApiKey}>
          <i className="fa-regular fa-gear fa-spin" />
          Change API details?
        </button>
      )}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default FivePaisa;
